import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import '../styles/Leaderboard.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const Leaderboard = () => {
  const [players, setPlayers] = useState([]);
  const [months, setMonths] = useState([]);
  const [filter, setFilter] = useState('Total');
  const [sortOrder, setSortOrder] = useState('asc');
  const [sortBy, setSortBy] = useState('name');

  useEffect(() => {
    api.get('/api/stats/months')
      .then(response => setMonths(response.data))
      .catch(error => console.error("Error fetching months", error));
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const endpoint =
          filter === 'Total'
            ? '/api/stats/total'
            : '/api/stats/month';

        const response = await api.get(endpoint, {
          params:
            filter === 'Total'
              ? { sortBy, sortOrder }
              : { value: filter, sortBy, sortOrder },
        });

        setPlayers(response.data);
      } catch (error) {
        console.error("Error fetching stats:", error);
      }
    };

    fetchData();
  }, [filter, sortBy, sortOrder]);

  const handleSort = (field) => {
    setSortOrder((prev) => (prev === 'asc' ? 'desc' : 'asc'));
    setSortBy(field);
  };

  const getArrow = (field) => {
    return sortBy === field ? (sortOrder === 'asc' ? '↑' : '↓') : '↑';
  };

  return (
    <div className="leaderboard-container">
      <h2>Leaderboard</h2>

      <div className="dropdown mb-4">
        <button
          className="btn btn-secondary dropdown-toggle"
          type="button"
          id="monthDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {filter}
        </button>
        <ul className="dropdown-menu" aria-labelledby="monthDropdown">
          <li>
            <button className="dropdown-item" onClick={() => setFilter('Total')}>
              All Time Stats
            </button>
          </li>
          {months.map((month) => (
            <li key={month}>
              <button className="dropdown-item" onClick={() => setFilter(month)}>
                {month}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className="table-container">
        <table className="leaderboard-table">
          <thead>
            <tr>
              <th onClick={() => handleSort('name')}>Name {getArrow('name')}</th>
              <th onClick={() => handleSort('wins')}>Wins {getArrow('wins')}</th>
              <th onClick={() => handleSort('losses')}>Losses {getArrow('losses')}</th>
              <th onClick={() => handleSort('kills')}>Kills {getArrow('kills')}</th>
              <th onClick={() => handleSort('deaths')}>Deaths {getArrow('deaths')}</th>
              <th onClick={() => handleSort('winPercent')}>Win % {getArrow('winPercent')}</th>
              <th onClick={() => handleSort('totalGames')}>Games {getArrow('totalGames')}</th>
              <th onClick={() => handleSort('winLossRatio')}>W/L Ratio {getArrow('winLossRatio')}</th>
              <th onClick={() => handleSort('kdRatio')}>K/D Ratio {getArrow('kdRatio')}</th>
            </tr>
          </thead>
          <tbody>
            {players.map((player, i) => (
              <tr key={player.name || player.playerName || i}>
                <td>{player.name || player.playerName}</td>
                <td>{player.wins}</td>
                <td>{player.losses}</td>
                <td>{player.kills}</td>
                <td>{player.deaths}</td>
                <td>{player.winPercent.toFixed(0)}%</td>
                <td>{player.totalGames}</td>
                <td>{player.winLossRatio.toFixed(2)}</td>
                <td>{player.kdRatio.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Leaderboard;
